﻿import {DateOnly, isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {DatePickerMessages} from "../HtmlControls/DatePicker";
import {MvvmPrefixedControlProps} from "./MvvmControlProps";
import MvvmPicker from "./MvvmPicker";

const dateToString = (value: DateOnly | undefined): string => value?.toJSON() ?? "";
const dateFromString = (value: string | undefined): DateOnly | undefined => {
	if (isNullOrEmpty(value)) return undefined;
	try {
		return DateOnly.fromIsoString(value);
	} catch {
		return undefined;
	}
};

export interface MvvmDatePickerProps<T extends object = never> extends MvvmPrefixedControlProps<T, DateOnly> {
	min?: DateOnly;
	max?: DateOnly;
	/** Commits the day on the click that picks it, with no OK/Cancel footer. */
	autoAccept?: boolean;
	messages?: DatePickerMessages;
	isSelectable?: (date: DateOnly) => boolean;
	dayClassName?: (date: DateOnly) => string | undefined;
}

export default function MvvmDatePicker<T extends object = never>(props: MvvmDatePickerProps<T>): JSX.Element {
	return <MvvmPicker<T, DateOnly> control={props}
	                                mode={"date"}
	                                min={props.min?.toJSON()}
	                                max={props.max?.toJSON()}
	                                autoAccept={props.autoAccept}
	                                messages={props.messages}
	                                isSelectable={props.isSelectable}
	                                dayClassName={props.dayClassName}
	                                valueToString={dateToString}
	                                valueFromString={dateFromString}/>;
};
